import { createPinia } from 'pinia'
export * from './modules'

const store = createPinia()

export { store }
